const getSearchName = (name) => {
  const part1 = name
    .split(/\(.*.\)/gi)
    .join('')
    .trim('');
  const part2 = name.replace(/\(|\)/gi, '').split(part1).join('').trim('');

  return [part1, part2 ? `Sede ${part2}` : part2].join(' ').trim();
};

export const getClinicsToSearch = (clinics) => {
  const { limaCallao, provinces } = clinics;

  return [...limaCallao, ...provinces].flatMap(({ name, list }) => list.map((clinic) => ({
    name,
    label: clinic,
    search: getSearchName(clinic) + (['Lima', 'Callao'].includes(name) ? '' : ` - ${name}`),
    location: ['Lima', 'Callao'].includes(name) ? 'limaCallao' : 'provinces',
    planData: {
      title: 'Plan Cobertura básica',
    },
  })));
};

export async function searchPlan(clinicData, text, by = 'search') {
  return clinicData.filter(({ search, label }) => {
    const byFilter = by === 'search' ? search : label;
    return byFilter.trim().toLowerCase() === text.trim().toLowerCase();
  });
}

export function convertClinicTree(data) {
  const clinicData = {
    limaCallao: [],
    provinces: [],
  };
  let location = 'limaCallao';

  data.forEach((item) => {
    if (!clinicData[item.location]) {
      clinicData[item.location] = [];
    }
    location = item.location;
    clinicData[item.location].push({
      name: item.name,
      list: [
        item.label,
      ],
    });
  });

  return {
    data: clinicData,
    location,
  };
}
